import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {getActivePermissions} = customer.selectors;

import {getCareSheetSettings, deleteAd, deselectAd, selectAd, uploadAd} from '../actions';
import {areSettingsValid, getAds, getSelectedAd, getPreviews} from '../selectors';

import PetAdPreview from './PetAdPreview';
import PetAdTable from './PetAdTable';

import * as permissions from '../../common/userPermissions';

class AdsPage extends React.Component {
  componentWillMount() {
    const accessPermission = this.props.activePermissions.find((permission) => {
      return permission === permissions.MANAGE_CARE_SHEET_ADS;
    });
    if(!accessPermission)
    {
      this.props.actions.push('/labels');
    } 

    this.props.actions.getCareSheetSettings();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.authData.activeSubscriptionId !== nextProps.authData.activeSubscriptionId) {
      this.props.actions.getCareSheetSettings();
    }
  }

  componentWillUnmount() {
    this.props.actions.deselectAd();
  }

  render() {
    const {actions: {deleteAd, selectAd, uploadAd}, adsList, previewsList, validSettings, selectedAd} = this.props;
    
    return (
      <div className="container-fluid main" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1>{I18n.t('ADVERTISING_SPACE')}</h1>
            <p>{I18n.t('ADVERTISING_DETAILS')}</p>
            {!validSettings && <div className="loading"/>} 
            {validSettings && <div><div className="row">
              <div className="col-lg-9 col-md-8">
                <PetAdTable adsList={adsList}
                            previewsList={previewsList}
                            onClearAd={deleteAd} 
                            onRowSelected={selectAd}
                            onUploadAd={uploadAd} 
                            selectedAd={selectedAd}/>
              </div>
              <div className="col-lg-3 col-md-4 text-right aspace">
                {Object.keys(selectedAd).length !== 0 && <PetAdPreview ad={selectedAd}/>}
              </div>
            </div> 
            </div>}
        </div>
      </div>
    </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    adsList: getAds(state),
    activePermissions: getActivePermissions(state),
    previewsList: getPreviews(state),
    validSettings: areSettingsValid(state),
    selectedAd: getSelectedAd(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getCareSheetSettings, deleteAd, deselectAd, selectAd, uploadAd, push}, dispatch)
  };
}

AdsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePermissions: PropTypes.array.isRequired,
  adsList: PropTypes.array.isRequired,
  previewsList: PropTypes.array.isRequired,
  validSettings: PropTypes.bool.isRequired,
  authData: PropTypes.object.isRequired,
  selectedAd: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(AdsPage);


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/AdsPage.js
 **/